import styled from 'styled-components';

export const SectionWrapper = styled.div`
    & + & {
        margin-top: 35px;
    }
`;

export const TitleSection = styled.h3`
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 1.4em;
`;

export const FormWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 5px 10px;
    @supports not (gap: inherit) {
        grid-gap: 5px 10px;
    }
    padding: 0;
    list-style: none;
`;

export const ButtonWrapper = styled.div`
    margin-top: 15px;
`;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/style.js
 **/